/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { QueryClient, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import fetch from '../../client.ts';
import { getInvestorDeclarationQueryResponseSchema } from '../schemas/getInvestorDeclarationSchema.ts';
import type {
  GetInvestorDeclaration505,
  GetInvestorDeclarationQueryResponse,
} from '../types/GetInvestorDeclaration.ts';

export const getInvestorDeclarationSuspenseQueryKey = () => ['USER_BACKEND', { url: '/investor_declaration' }] as const;

export type GetInvestorDeclarationSuspenseQueryKey = ReturnType<typeof getInvestorDeclarationSuspenseQueryKey>;

/**
 * {@link /investor_declaration}
 */
export async function getInvestorDeclarationSuspense(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetInvestorDeclarationQueryResponse,
    ResponseErrorConfig<GetInvestorDeclaration505>,
    unknown
  >({ method: 'GET', url: `/investor_declaration`, ...requestConfig });
  return getInvestorDeclarationQueryResponseSchema.parse(res.data);
}

export function getInvestorDeclarationSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getInvestorDeclarationSuspenseQueryKey();
  return queryOptions<
    GetInvestorDeclarationQueryResponse,
    ResponseErrorConfig<GetInvestorDeclaration505>,
    GetInvestorDeclarationQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getInvestorDeclarationSuspense(config);
    },
  });
}

/**
 * {@link /investor_declaration}
 */
export function useGetInvestorDeclarationSuspense<
  TData = GetInvestorDeclarationQueryResponse,
  TQueryKey extends QueryKey = GetInvestorDeclarationSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetInvestorDeclarationQueryResponse,
        ResponseErrorConfig<GetInvestorDeclaration505>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getInvestorDeclarationSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getInvestorDeclarationSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetInvestorDeclaration505>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
